import { render, staticRenderFns } from "./CreateDokter.vue?vue&type=template&id=086f6e38"
import script from "./CreateDokter.vue?vue&type=script&lang=js"
export * from "./CreateDokter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports